import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-info-saas-cadastro',
    templateUrl: './info-saas-cadastro.component.html',
    styleUrl: './info-saas-cadastro.component.css',
    standalone: false
})
export class InfoSaasCadastroComponent {
  @Input() color = "#193043";
  @Input() titulo = "Experimente agora uma rotina júridica com mais segurança, transparência para com os clientes e liberdade.";
  @Input() publicoAlvo = "advogados";
  @Input() imagem = "advogadaSemFundo.png";
  @Input() logo = "logoSemFundoPreta.png";
  @Input() corFundo = "rgba(25,48,67,0.17)";
}
